<template>
  <div class="sidebar-container" :class="{ 'is-collapse': isCollapse }">
    <div class="sidebar-brand" :class="{ 'is-collapse': isCollapse }">
      <router-link to="/dashboard" class="brand-link">
        <div class="logo">TD</div>
        <div class="name">管理系统</div>
      </router-link>
    </div>
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        ref="menuRef"
        :default-active="activeMenu"
        :collapse="isCollapse"
        :unique-opened="true"
        :collapse-transition="false"
        background-color="#121e2d"
        text-color="#bfcbd9"
        active-text-color="#fff"
        mode="vertical"
        router
        @select="handleMenuSelect"
      >
        <sidebar-item
          v-for="route in menuRoutes"
          :key="route.path"
          :item="route"
          :base-path="route.path"
          :is-collapse="isCollapse"
          
        />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem.vue'

export default {
  name: 'AppSidebar',
  components: { 
    SidebarItem
  },
  props: {
    isCollapse: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedKey: null,
      rippleDuration: 600,
    }
  },
  computed: {
    ...mapGetters('permission', ['menus']),
    menuRoutes() {
      return this.menus || []
    },
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    }
  },
  methods: {
    handleMenuSelect(key, keyPath) {
      this.selectedKey = key
      this.createRippleEffect(key)
      this.$emit('menu-select', { key, keyPath })
    },
    
    createRippleEffect(menuKey) {
      const menuItems = document.querySelectorAll('.el-menu-item, .el-sub-menu__title')
      menuItems.forEach(item => {
        if (item.dataset.key === menuKey || item.textContent.includes(this.getMenuTitle(menuKey))) {
          this.createRipple(item)
        }
      })
    },
    
    createRipple(element) {
      const existingRipple = element.querySelector('.ripple')
      if (existingRipple) {
        existingRipple.remove()
      }
      
      const ripple = document.createElement('span')
      const rect = element.getBoundingClientRect()
      const size = Math.max(rect.width, rect.height)
      const x = event ? event.clientX - rect.left - size / 2 : rect.width / 2
      const y = event ? event.clientY - rect.top - size / 2 : rect.height / 2
      
      ripple.style.width = ripple.style.height = size + 'px'
      ripple.style.left = x + 'px'
      ripple.style.top = y + 'px'
      ripple.classList.add('ripple')
      
      element.style.position = 'relative'
      element.style.overflow = 'hidden'
      element.appendChild(ripple)
      
      setTimeout(() => {
        ripple.remove()
      }, this.rippleDuration)
    },
    
    getMenuTitle(menuKey) {
      const findMenu = (routes) => {
        for (const route of routes) {
          if (route.path === menuKey) return route.meta?.title
          if (route.children) {
            const found = findMenu(route.children)
            if (found) return found
          }
        }
        return null
      }
      return findMenu(this.menuRoutes)
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebar-container {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 1001;
  width: 210px;
  background-color: var(--color-sidebar-bg);
  box-shadow: 2px 0 12px rgba(0, 0, 0, 0.1);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;

  &.is-collapse {
    width: 64px;
    
    .collapse-btn {
      justify-content: center;
      padding: 0;
      
      .collapse-text {
        display: none;
      }
      
      i.el-icon {
        transform: rotate(180deg);
      }
    }
  }

  ::v-deep {
    .scrollbar-wrapper {
      overflow-x: hidden !important;
      height: calc(100% - 64px);
      
      .el-scrollbar__view {
        height: 100vh;
        padding-bottom: 60px;
      }
    }

      .el-menu {
        border: none;
        height: 100%;
        width: 100% !important;
      transition: width 0.25s ease, padding 0.25s ease;
      
      // 统一移除链接下划线与伪元素线
      a,
      a:hover,
      a:active,
      a.router-link-active {
        text-decoration: none !important;
        border: none !important;
        outline: none !important;
        display: block;
      }
      a::after,
      a::before,
      a.router-link-active::after,
      a.router-link-active::before {
        content: '' !important;
        display: none !important;
        border: 0 !important;
      }

      // 菜单项点击效果
      .el-menu-item,
      .el-sub-menu__title {
        position: relative;
        overflow: hidden;
        transition: all 0.2s ease;
        margin: 4px 8px;
        border-radius: var(--radius-sm);
        border-bottom: none !important;
        
        // 核心：强制去掉所有文本装饰和边框
        text-decoration: none !important;
        border: none !important;
        outline: none !important;
        box-shadow: none !important;
        
        // 防止伪元素产生下划线
        &::after,
        &::before {
          content: '' !important;
          display: none !important;
          border: 0 !important;
        }

        // 同步屏蔽内部链接的伪元素线
        a::after,
        a::before,
        a:hover::after,
        a:hover::before,
        a:active::after,
        a:active::before,
        a.router-link-active::after,
        a.router-link-active::before {
          content: '' !important;
          display: none !important;
          border: 0 !important;
        }

        &:hover,
        &:active,
        &.is-active {
          border-bottom: none !important;
        }

        &:hover::after,
        &:hover::before,
        &:active::after,
        &:active::before,
        &.is-active::after {
          display: none !important;
          border: 0 !important;
        }

        &:last-child {
          border-bottom: none !important;
          margin-bottom: 6px;
        }
        
        &:hover {
          background-color: var(--nav-hover-bg) !important;
          transform: translateX(4px);
          text-decoration: none !important;
        }
        
        &.is-active {
          background: var(--nav-active-bg) !important;
          color: var(--color-white) !important;
          font-weight: 600;
          text-decoration: none !important;
          border: none !important;
          box-shadow: 0 2px 8px rgba(64, 158, 255, 0.12) !important;
          
          
          // 激活状态指示条
          &::before {
            content: '' !important;
            position: absolute;
            left: 0;
            top: 0;
            bottom: 0;
            width: 4px;
            background: var(--color-white);
            border-radius: 0 2px 2px 0;
            box-shadow: 0 0 8px var(--nav-indicator-shadow);
          }

          &::after {
            content: '';
            position: absolute;
            right: 10px;
            top: 50%;
            transform: translateY(-50%);
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background: var(--nav-badge-bg);
            box-shadow: 0 0 6px var(--nav-indicator-shadow);
          }

          .menu-item-content .menu-title,
          .menu-item-content .menu-icon {
            color: var(--color-white) !important;
          }
        }
        
        // 波纹效果
        .ripple {
          position: absolute;
          border-radius: 50%;
          background-color: rgba(255, 255, 255, 0.3);
          transform: scale(0);
          animation: ripple 0.6s linear;
        }
      }
      
      // 子菜单样式
      .el-sub-menu {
        &.is-opened {
          > .el-sub-menu__title {
            background-color: rgba(255, 255, 255, 0.05);
            color: #fff !important;
            text-decoration: none !important;
            border: none !important;
            border-radius: var(--radius-sm);
          }
          > .el-menu {
            transition: max-height 0.25s ease, opacity 0.25s ease;
            max-height: 600px;
            opacity: 1;
          }
        }
        
        // 子菜单激活状态
        &.is-active {
          > .el-sub-menu__title {
            color: var(--color-white) !important;
            background: var(--nav-active-bg) !important;
            text-decoration: none !important;
            border: none !important;
            box-shadow: 0 2px 8px rgba(64, 158, 255, 0.12) !important;
            
            &::before {
              content: '' !important;
              position: absolute;
              left: 0;
              top: 0;
              bottom: 0;
              width: 4px;
              background: var(--color-white);
              border-radius: 0 2px 2px 0;
              box-shadow: 0 0 8px var(--nav-indicator-shadow);
            }
            
            &::after {
              content: '';
              position: absolute;
              right: 10px;
              top: 50%;
              transform: translateY(-50%);
              width: 6px;
              height: 6px;
              border-radius: 50%;
              background: var(--nav-badge-bg);
              box-shadow: 0 0 6px var(--nav-indicator-shadow);
            }
            
            .menu-item-content .menu-title,
            .menu-item-content .menu-icon {
              color: var(--color-white) !important;
            }
          }
        }
        
        .el-menu {
          background-color: rgba(0, 0, 0, 0.2) !important;
          transition: max-height 0.25s ease, opacity 0.25s ease;
          max-height: 0;
          opacity: 0;
          
          .el-menu-item {
            margin: 2px 8px;
            text-decoration: none !important;
            border: none !important;
            border-bottom: none !important;

            &::after,
            &::before,
            &:hover::after,
            &:hover::before,
            &:active::after,
            &:active::before,
            &.is-active::after {
              content: '' !important;
              display: none !important;
              border: 0 !important;
            }
            
            &:hover {
              background-color: var(--nav-hover-bg) !important;
              text-decoration: none !important;
            }

            // 屏蔽子项内部链接的伪元素线
            a,
            a:hover,
            a:active,
            a.router-link-active {
              text-decoration: none !important;
              border: none !important;
              outline: none !important;
              display: block;
            }
            a::after,
            a::before,
            a:hover::after,
            a:hover::before,
            a:active::after,
            a:active::before,
            a.router-link-active::after,
            a.router-link-active::before {
              content: '' !important;
              display: none !important;
              border: 0 !important;
            }
            
            &.is-active {
              background-color: var(--nav-active-bg) !important;
              text-decoration: none !important;
              border: none !important;
              
              &::before {
                left: 8px; // 调整子菜单激活指示条位置
                width: 2px;
              }
            }
          }
        }
      }
    }
  }

  .slide-fade-enter-active,
  .slide-fade-leave-active {
    transition: all 0.2s ease;
  }
  .slide-fade-enter,
  .slide-fade-leave-to {
    opacity: 0;
    transform: translateY(-6px);
  }

  .collapse-btn {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 0 20px;
    background-color: rgba(0, 0, 0, 0.2);
    color: #bfcbd9;
    cursor: pointer;
    transition: all 0.3s ease;
    border-top: none;
    text-decoration: none !important;
    
    &:hover {
      background-color: rgba(255, 255, 255, 0.1);
      color: #fff;
      text-decoration: none !important;
      
      i.el-icon {
        transform: translateX(-2px);
      }
    }
    
    i.el-icon {
      font-size: 18px;
      margin-right: 8px;
      transition: transform 0.3s ease;
      text-decoration: none !important;
      
      &.rotate-180 {
        transform: rotate(180deg);
        
        &:hover {
          transform: rotate(180deg) translateX(-2px);
        }
      }
    }
    
    .collapse-text {
      font-size: 14px;
      white-space: nowrap;
      overflow: hidden;
      transition: all 0.3s ease;
      text-decoration: none !important;
    }
  }
}

.sidebar-brand {
  height: 64px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  border-bottom: 1px solid rgba(255,255,255,0.06);
}

.brand-link {
  display: flex;
  align-items: center;
  text-decoration: none;
}

.logo {
  width: 28px;
  height: 28px;
  border-radius: 6px;
  background: linear-gradient(135deg, #409EFF, #66b1ff);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 14px;
  margin-right: 8px;
}

.name {
  font-size: 15px;
  font-weight: 600;
  color: #ffffff;
}

.sidebar-container.is-collapse .name {
  display: none;
}

.sidebar-container.is-collapse .sidebar-brand {
  justify-content: center;
}

@keyframes ripple {
  to {
    transform: scale(4);
    opacity: 0;
  }
}

// 响应式调整
@media screen and (max-width: 768px) {
  .sidebar-container {
    transform: translateX(-100%);
    
    &:not(.is-collapse) {
      transform: translateX(0);
      width: 240px;
    }
    
    &.is-collapse {
      transform: translateX(-100%);
    }
  }
}
</style>
